/** Hermes 发送队列（Cursor 式：生成中可入队，可编辑/删除/插队打断）。 */

export type HermesQueuedMessage = {
  id: string;
  content: string;
  createdAt: number;
};

export function newQueuedMessageId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `q-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function createQueuedMessage(content: string): HermesQueuedMessage | null {
  const trimmed = content.trim();
  if (!trimmed) return null;
  return {
    id: newQueuedMessageId(),
    content: trimmed,
    createdAt: Date.now(),
  };
}

export function enqueueHermesMessage(
  queue: HermesQueuedMessage[],
  content: string,
): HermesQueuedMessage[] {
  const item = createQueuedMessage(content);
  if (!item) return queue;
  return [...queue, item];
}

export function updateHermesQueuedMessage(
  queue: HermesQueuedMessage[],
  id: string,
  content: string,
): HermesQueuedMessage[] {
  const trimmed = content.trim();
  if (!trimmed) return queue.filter((item) => item.id !== id);
  return queue.map((item) => (item.id === id ? { ...item, content: trimmed } : item));
}

export function removeHermesQueuedMessage(
  queue: HermesQueuedMessage[],
  id: string,
): { queue: HermesQueuedMessage[]; removed: HermesQueuedMessage | null } {
  const removed = queue.find((item) => item.id === id) ?? null;
  return {
    queue: queue.filter((item) => item.id !== id),
    removed,
  };
}

export function shiftHermesQueuedMessage(
  queue: HermesQueuedMessage[],
): { queue: HermesQueuedMessage[]; next: HermesQueuedMessage | null } {
  if (queue.length === 0) return { queue, next: null };
  const [next, ...rest] = queue;
  return { queue: rest, next: next ?? null };
}
